import React, {useEffect, useState} from "react";
import {View, StyleSheet} from "react-native";
import {Color, globalFontStyle} from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import {useForm, useFormState} from "react-hook-form";
import {Input} from "../../../components/core/Input";
import {RegEx} from "../../../utils/commonMethods";
import {Network} from "../../../utils/network";
import {useDispatch} from "react-redux";
import {getBankDetails} from "../redux/profile.action";
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import {Button} from "../../../components/core/Button";
import {globalConfigurableData} from '../../../utils/globalConstant';
import {trackMoengageEvent} from '../../../utils/commonMethods';

const AddOnlyBankDetails = ({kycDetails = null}) => {
  const {
    control,
    formState: {errors, isValid},
    handleSubmit,
    reset,
    watch,
  } = useForm({mode: "onChange"});

  const accountNumber = watch("accountNumber");
  const accountNumberCheck = watch("accountNumberCheck");

  useEffect(() => {
    const bankdetails = kycDetails?.bankdetails;
    const PAN = kycDetails?.number;
    const accountHolderName = bankdetails?.name;
    const ifsc = bankdetails?.ifsc;
    const accountNumber = bankdetails?.accountnumber;
    let defaultValues = {};
    defaultValues.PANNO = PAN;
    defaultValues.ifsc = ifsc;
    defaultValues.accountNumber = accountNumber;
    defaultValues.accountNumberCheck = accountNumber;

    reset({...defaultValues});
  }, [kycDetails]);

  const dispatch = useDispatch();
  const {isDirty} = useFormState({control});
  const [apiSuccess, setApiSuccess] = useState("");
  const [respError, setResponseError] = useState("");

  const onClickBankUpdate = async (details, e) => {
    if (isDirty) {
      e.preventDefault();
      const data = {
        accountNumber: details.accountNumberCheck,
        ifsc: details.ifsc,
      };

      const res = await Network.addNewBank(data, true);
      if (!res?.data?.success) {
        dispatch(getBankDetails());
        setResponseError(res?.data?.error);
      } else {
        dispatch(getBankDetails());
        trackMoengageEvent("KYC Details", {
          Status: "complete",
          PAN: details.PANNO,
          IFSC: details.ifsc,
          AccountNo: details.accountNumberCheck,
          Time: new Date(),
        });
        setApiSuccess("Your KYC verification has been successful!");
      }
    } else {
      setResponseError("Nothing to Update");
    }
  };

  useEffect(() => {
    if (isDirty) {
      setResponseError("");
    }
  }, [isDirty]);

  return (
    <View style={styles.container}>
      <Input
        name="PANNO"
        placeholder="Write PAN number here"
        control={control}
        label="PAN Number"
        variant="default"
        size="default"
        formatter="pan"
        disabled={true}
        rules={{
          required: "Please enter PAN No",
          pattern: {
            value: RegEx.pan,
            message: "Please enter a valid PAN",
          },
        }}
      />

      <Input
        name="ifsc"
        placeholder="Write IFSC Code here"
        control={control}
        label="IFSC Code"
        variant="default"
        size="default"
        formatter="ifsc"
        rules={{
          required: "Please enter IFSC code",
          pattern: {
            value: RegEx.ifsc,
            message: "Please enter a valid IFSC",
          },
        }}
      />

      <Input
        name="accountNumber"
        placeholder="Please enter a valid Account Number"
        control={control}
        label="Account Number"
        variant="default"
        size="default"
        numeric={true}
        rules={{
          required: "Please enter account number",
          pattern: {
            value: RegEx.accountNum,
            message: "Please enter a valid Account Number",
          },
        }}
      />

      <Input
        name="accountNumberCheck"
        placeholder="Re-enter Account Number"
        control={control}
        label="Confirm Account Number"
        variant="default"
        size="default"
        numeric={true}
        rules={{
          required: true,
          validate: {
            equal: (value) => value === accountNumber || "The account numbers don't match",
          },
        }}
      />

      <FormTextLabel
        labelStyles={styles.infoText}
        label={"Please double-check your details before submitting to avoid delays in withdrawal. Please note that PAN details cannot be changed post-submission."}
      />

      {respError && (
        <FormTextLabel
          labelStyles={styles.errorText}
          label={respError}
        />
      )}
      {apiSuccess && (
        <FormTextLabel
          labelStyles={[styles.errorText, {color: Color.green}]}
          label={apiSuccess}
        />
      )}

      <Button
        variant="primary"
        onPress={handleSubmit(onClickBankUpdate)}
        translate={true}
      >
        Submit
      </Button>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingTop: 16,
  },
  errorText: {
    ...globalFontStyle.appFontSmallText,
    color: Colors.red,
    marginBottom: 8,
  },
  infoText: {
    ...globalFontStyle.appFontSmallText,
    color: Colors.grey,
    marginBottom: 16,
  },
});

export default AddOnlyBankDetails;
